<template>
  <div class="add-area-form">
    <el-dialog
      title="新增片区"
      :close-on-click-modal="false"
      @close="close"
      :before-close="close"
      visible
    >
      <el-form
        inline
        ref="formData"
        :rules="rules"
        :model="formData"
        label-width="110px"
        label-position="right"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="上级片区" class="half-line" prop="belongZone">
              <el-cascader
                :options="zoneList"
                :props="props"
                @change="handleChange"
                placeholder="请选择片区"
                change-on-select
              >
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="新增片区"
              class="half-line"
              prop="newArea"
            >
              <el-input @change="textChange" placeholder="请输入片区"></el-input>
            </el-form-item>
          </el-col>
         
        </el-row>
        

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="add-house" @click="this.close"
          >取消</el-button
        >
        <el-button
          type="primary"
          :loading="isLoading"
          @click="sure('formData')"
          >提 交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>

import accountApi from '@/xhr/services/account'

export default {
  data() {
    var zoneCheck = (rule, value, callback) => {
      let { parentid } = this.formData
      if (!parentid || parentid.length < 1) {
        callback('请选择归属片区')
      } else if (Array.isArray(parentid)) {
        callback()
      }
    }
    var newArea = (rule, value, callback) => {
      let { name } = this.formData
      if (!name || name === '') {
        callback('请输入新增片区')
      } else if (name !== '') {
        callback()
      }
    }
    
    return {
      // houseTypeEum,
      formData: {
        parentid: [], // 片区ID
        name: '',
        flag: 'area',
        paramsId: ''
      },
      isLoading: false,
      companyLoading: false,
      zoneList: [],
      props: {
        value: 'id',
        label: 'text',
      },
      waiter: null,
      rules: {
        belongZone: [{ required: true, validator: zoneCheck }],
        newArea: [{ required: true, validator: newArea }],
      },
    }
  },
  props: {},
  watch: {},
  created() {
    this.getScopeId()
  },
  computed: {},
  methods: {
    close() {
      this.$emit('closeAddArea')
    },
  //  选择上级片区
    handleChange(val) {
      this.formData.parentid = val
      if (val.length === 1) {
              this.formData.paramsId = val[0]
            } else if (val.length === 2) {
              this.formData.paramsId = val[1]
            }
    },
    // 输入新增片区
    textChange(val) {
      this.formData.name = val
    },
    
    // 获取片区对应的片区命
    getZoneName(zoneId) {
      let unitName = ''
      if (this.zoneList.length) {
        this.zoneList.forEach(item => {
          if (
            item.children &&
            Array.isArray(item.children) &&
            item.children.length
          ) {
            item.children.forEach(tip => {
              if (tip.id === zoneId) {
                unitName = tip.text
              }
            })
          }
        })
      }
      return unitName
    },
  
    // 二次确认提交弹框
    sure(val) {
       this.$refs[val].validate(valid => {
         if (valid) {
          this.isLoading = true
      this.$confirm('请确认是否新增该片区', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          let params = {
            flag: 'area',
            name: this.formData.name,
            parentid: this.formData.paramsId
          }
           accountApi.addArea(params).then(res => {
          if (res.data.code === 200) {
             this.$message.success('新增片区成功')
             this.close()

          } else {
             this.$message.warning(`新增片区失败, 原因:${res.data.message}`)
             this.isLoading = false
          }
        })
        }).catch(() => {
        this.isLoading = false
      })
         }
        })
    },

getScopeId() {
      accountApi.getUnitTree().then(res => {
        // console.log(res.data.data.children)
        if (res.data.code === 200) {
          let arr = []
          arr = res.data.data.children
          // 只取后台返回4层数据的2、3层数据
          for (var i = 0; i < arr.length; i++) {
            for (var j = 0; j < arr[i].children.length; j++) {
               arr[i].children[j].children = null
               this.zoneList = arr
            }
          }
        } else {
          this.zoneList = []
        }
      })
    },

  },
  filters: {
    // dealWithBlank, // 去除字符串两端空格
  },
}
</script>
<style lang="scss" scoped>
.house-withdraw-form {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #333333;
  position: relative;
  .all-line {
    width: 100%;
    .inline-input {
      width: 100%;
    }
  }
  .title-alert {
    position: relative;
    font-size: 14px;
    color: red;
    font-weight: bold;
    top: -52px;
    left: 80px;
  }
  .delete-button {
    position: relative;
    top: 4px;
    left: 5px;
  }
  .add-house {
    position: absolute;
    left: 20px;
  }
}
</style>
<style>
/* 修改 element-ui 样式 */
.house-withdraw-form .all-line .el-form-item__content {
  width: 77.5%;
}
.house-withdraw-form .all-line .el-form-item__content .el-cascader {
  width: 100%;
}
.house-withdraw-form .el-input__icon + .el-input__inner {
  padding-right: 10px;
}
.house-withdraw-form .el-dialog {
  width: 665px !important;
}
.house-withdraw-form .el-dialog__title {
  font-size: 18px;
  font-weight: bold;
}
/* 红色按钮样式 */
.house-withdraw-form .delete-button:active {
  color: #fff;
  border-color: #e64242;
}
.house-withdraw-form .delete-button:hover {
  color: #ff6d6d;
  border-color: #ff6d6d;
  color: #fff;
}
.house-withdraw-form .delete-button:focus {
  background: #ff6d6d;
  border-color: #ff6d6d;
  color: #fff;
}
</style>
<style lang="scss">
.house-withdraw-form {
  .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 110px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/AddAreaForm/index.vue